<template>
  <!-- prettier-ignore -->
  <div class="partner">
    <ovp-text-input
      v-model="value.salesPartnerEmail"
      name="email"
      :theme="theme"
      type="email"
      :title="$t('basket.advisorEmail')"
      :validate="v.salesPartnerEmail"
    />
  </div>
</template>

<script>
export default {
  name: 'OvpPartner',

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    theme: {
      type: String,
      default: 'light',
    },

    v: {
      type: Object,
      required: true,
    },

    value: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style></style>
